import IApiClient from "./ApiClient";
import {ChangeLogResponse} from "models/ChangeLog"

export interface IChangeLogService {
    getChangeLog(companyId: string): Promise<ChangeLogResponse | undefined>;
  }

export default class ChangeLogService implements IChangeLogService{
    apiBase: string;
    apiClient: IApiClient;
  
    constructor(apiClient: IApiClient) {
      this.apiBase = '/api/changelog';
      this.apiClient = apiClient;
    }
  
    async getChangeLog(companyId: string): Promise<ChangeLogResponse|undefined> {
      try {
        const response = await this.apiClient.get<ChangeLogResponse>(
          `${this.apiBase}/get/${companyId}`
        );
        return response ? response : undefined;
      } catch (exception) {
        console.error(exception);
      }
    }
  }